import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import { FaqSection, AboutSection, TopicsSection, CarouselSection, RankingSection } from './components/SectionsA';
import { IndexSection, UpdatesSection, CommentsSection } from './components/SectionsB';
import { FeaturesSection, ContactSection, CardsSection, AppSection, MediaSection } from './components/SectionsC';

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <AboutSection />
        <TopicsSection />
        <CarouselSection />
        <RankingSection />
        <IndexSection />
        <UpdatesSection />
        <CommentsSection />
        <FeaturesSection />
        <ContactSection />
        <CardsSection />
        <AppSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}